/* Syllabus — artboard 2b, "single trail".

   The whole course as one continuous rail. Nothing branches; you climb in order.
*/

import s from './Syllabus.module.css';
import { Kicker } from '../design/primitives.jsx';
import { kindLabel } from '../design/tokens.js';
import { unitName } from '../content/course.js';

const cx = (...v) => v.filter(Boolean).join(' ');
const GLYPH = { done: '✓', locked: '', active: '→', next: '→', open: '' };

const TrailLesson = ({ lesson, onOpen }) => {
  const st = lesson.status;
  const locked = st === 'locked';
  return (
    <button type="button" disabled={locked} onClick={() => onOpen?.(lesson)}
            className={cx(s.lesson, locked && s.lessonLocked, st === 'active' && s.current)}>
      <span className={cx(s.glyph, st === 'done' && s.done, locked && s.locked)} aria-hidden="true">
        {GLYPH[st]}
      </span>
      <span className={s.lessonTitle}>{lesson.title}</span>
      <span className={s.lessonMeta}>{kindLabel[lesson.kind]}</span>
    </button>
  );
};

export default function Syllabus({ course, stats, onOpen }) {
  return (
    <div className={s.syllabus}>
      <div className={s.head}>
        <Kicker spacing="wide">THE WHOLE PATH</Kicker>
        <h1 className={s.title}>{course.title}</h1>
        <p className={s.sub}>
          {stats.total} lessons in one line. Nothing branches — you climb in order.
        </p>
      </div>
      <div className={s.trail}>
        {course.units.map(u => (
          <section key={u.id}>
            <div className={s.unitRow}>
              <span className={cx(s.unitNum, s[u.status])}>{u.num}</span>
              <h2 className={s.unitName}>{unitName(u)}</h2>
              {u.meta && <span className={s.unitMeta}>{u.meta}</span>}
            </div>
            {u.lessons.map(l => <TrailLesson key={l.id} lesson={l} onOpen={onOpen} />)}
          </section>
        ))}
      </div>
    </div>
  );
}
